// @flow

import type { BuildFormat } from '../types/flow/BuildFormat';

export default ([
  'cjs',
  'esm',
]: BuildFormat[]);
